import React from 'react';
import './discoverersHameltemSection.scss';
import {useTranslation} from "react-i18next";

const DiscoverersHameltemSection = () => {
	const { t } = useTranslation();

	const scrollToBlock = (blockClass: string) => {
		const block = document.querySelector(`.${blockClass}`);
		if (block) {
			block.scrollIntoView({ behavior: 'smooth' });
		}
	};

	return (
		<div className="discoverersHameltemSection">
			<div className={`main__bg_animations_item c3`} />
			<div className={`main__bg_animations_item c4`} />
			<div className={`main__bg_animations_item c5`} />
			<div className="discoverersHameltemSection__content">
				<div className="discoverersHameltemSection__content_image">
					<img
						className={`mainLogo`}
						src={`${process.env.PUBLIC_URL}/assets/images/LogoHameltenproFooter.webp`}
						alt={`Logo image`}
					/>
				</div>
				<div className="discoverersHameltemSection__content_text">
					<p dangerouslySetInnerHTML={{ __html: t('discoverersHameltem') }}></p>
				</div>
				<div className="discoverersHameltemSection__content_btn">
					<button
						className={`mainButton`}
						onClick={() => scrollToBlock('collection')}
					>
						<span>{t('buttons.seeOurCollections')}</span>
					</button>
				</div>
			</div>
		</div>
	);
};

export default DiscoverersHameltemSection;